<!--<pre>tabList: {{tabList|json}}</pre>-->
<mat-tab-group  mat-stretch-tabs="false" animationDuration="0ms" class="line mt-8"
                [(selectedIndex)]="tabIndex" (selectedIndexChange)="handleTabChange($event)"
>
  <ng-container *ngFor="let tab of tabList; index as i">
    <mat-tab *ngIf="tab['privilege']" [label]="utils.mapKeyToString(TabListLabelDetailDistributor, tab['labelKey'])">
      <ng-container *ngIf="i === tabIndex && tab.component">
        <ng-container *ngComponentOutlet="tab.component"></ng-container>
      </ng-container>
    </mat-tab>
  </ng-container>
</mat-tab-group>
